import { mapState, mapGetters, mapActions } from 'vuex'

export const loadingComputed = {
  ...mapState('loading', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('loading', ['getLoading']),
}

export const loadingMethods = mapActions('loading', [
  'showLoading',
  'hideLoading',
])
